import logoImage from '@/assets/images/logo-cour-des-comptes.png'

export const DEFAULT_LOGO_PROPS = {
  src: logoImage,
  alt: "Logo Cour des Comptes",
  screen_size: {
    mobile_s: 60,
    mobile_m: 60,
    mobile_l: 60,
    tablet: 180,
    laptop: 180,
    laptop_l: 180,
    desktop: 180,
    k_screen: 180,
  },
  className: "rounded-md w-full object-cover",
}

